import { render } from "./jtabBar.vue?vue&type=template&id=28e4d16a&scoped=true&ts=true"
import script from "./jtabBar.vue?vue&type=script&lang=ts"
export * from "./jtabBar.vue?vue&type=script&lang=ts"

import "./jtabBar.vue?vue&type=style&index=0&id=28e4d16a&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e4d16a"]])

export default __exports__